(() => {
  "use strict";

  const base = (Shopify?.routes?.root || "/").replace(/\/$/, "");
  let inflight = false;

  async function fetchDrawerHTML() {
    for (const url of [
      `${base}/cart?section_id=cart-drawer`,
      `${base}/?section_id=cart-drawer`,
    ]) {
      const res = await fetch(url, { headers: { Accept: "text/html,*/*" } });
      const html = await res.text();
      // only accept real HTML
      if (res.ok && /<[^>]+>/.test(html)) return html;
    }
    return null;
  }

  async function refreshAndOpen() {
    if (inflight) return;
    const drawer = document.querySelector("cart-drawer");
    if (!drawer) return;

    inflight = true;
    try {
      const html = await fetchDrawerHTML();
      if (html) {
        const tmp = document.createElement("div");
        tmp.innerHTML = html;
        const incoming = tmp.querySelector("cart-drawer");
        // inject inner only so we don’t replace the element instance
        drawer.innerHTML = incoming ? incoming.innerHTML : html;
      }

      if (typeof drawer.show === "function") {
        await drawer.show(true);
      } else if (typeof drawer.open === "function") {
        drawer.open();
      } else {
        drawer.setAttribute("open", "");
      }
    } finally {
      inflight = false;
    }
  }

  // Event your configurator fires *after* it adds to cart:
  // window-level global event bus
  window.addEventListener("air:cart:open", (event) => {
    // event?.detail is available if you ever pass data
    refreshAndOpen();
  });
})();
